import React, { FunctionComponent, CSSProperties } from "react";
import SVG from "react-inlinesvg";
import icons from "./svg";

type IconSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

const iconSize = {
  1: "12px",
  2: "14px",
  3: "16px",
  4: "18px",
  5: "20px",
  6: "22px",
  7: "24px",
  8: "44px",
  9: "71px",
};

interface Props {
  name: string;
  size?: IconSize;
  fillRule?: "nonzero" | "evenodd";
  onClick?: (
    event: React.MouseEvent<SVGElement, MouseEvent> | MouseEvent
  ) => void;
  color?: string;
  style?: CSSProperties;
  loader?: JSX.Element;
  hide?: boolean;
  test?: boolean;
}

const Icon: FunctionComponent<Props> = ({
  size,
  name,
  color,
  fillRule,
  style,
  onClick,
  loader,
  hide,
  test,
}: Props) => {
  return (
    <SVG
      src={test ? "test.svg" : icons[name]}
      width={iconSize[size]}
      height={iconSize[size]}
      cacheRequests
      fillRule={fillRule}
      onClick={onClick}
      style={{ marginLeft: 10, marginRight: 10, ...style }}
      stroke={color}
      loader={loader}
      visibility={hide ? "hidden" : "visible"}
    />
  );
};

Icon.defaultProps = {
  onClick: null,
  size: 2,
  fillRule: null,
  color: "",
  style: null,
  loader: null,
  hide: false,
  test: false,
};

export default Icon;
